import clsx from 'clsx';

import { PendingChangeKind } from 'constants/pendingChanges';
import { getConditionalObject } from 'utils/data';

import { getMaskInputStyles } from './TextFieldCDS.styles';

const NOT_MASKED_CHARS = ['-', '_'];

export const getMaskedValue = ({ value, shownChars }) =>
  value
    .slice(0, value.length - shownChars)
    .split('')
    .map(char => (NOT_MASKED_CHARS.includes(char) ? char : '•'))
    .join('') + value.slice(-shownChars);

const getMaskInputProps = isMasked => ({
  sx: getMaskInputStyles(isMasked),
  'data-is-mask': true,
});

export const getSlotProps = ({
  ariaLabel,
  InputProps,
  maxLength,
  inputProps,
  error,
  isMaskFormat,
  isMasked,
  forMaskInput,
  changeKind,
  multiple,
  size,
  minValue,
  maxValue,
  isMultiline,
}) => ({
  input: {
    ...getConditionalObject(forMaskInput, () => ({
      ...getMaskInputProps(false),
      className: 'truncate',
    })),
    ...InputProps,
    'data-change-kind': changeKind,
    'data-is-changed': changeKind === PendingChangeKind.DIRECT,
    'data-is-multiple': multiple,
    size,
  },
  ...getConditionalObject(!forMaskInput, () => ({
    formHelperText: {
      error,
    },
    htmlInput: {
      ...inputProps,
      ...getConditionalObject(!!ariaLabel, () => ({ 'aria-label': ariaLabel })),
      ...getConditionalObject(maxLength !== undefined, {
        maxLength,
      }),
      ...getConditionalObject(minValue !== undefined, {
        min: minValue,
      }),
      ...getConditionalObject(maxValue !== undefined, {
        max: maxValue,
      }),
      ...getConditionalObject(isMaskFormat, () => getMaskInputProps(isMasked)),
      className: clsx(getConditionalObject(!isMultiline, 'truncate'), inputProps?.className),
      'data-truncated': !isMasked,
    },
  })),
});
